export class BambuserLiveShoppingError extends Error {
  constructor(message) {
    super(message);
    this.name = 'BambuserLiveShoppingError';
  }
}
